export const handleType = ({ namespace, type }) => {
  for (let key in type) {
    type[key] = namespace + type[key];
  }
};
